var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("channels-stores-tab", { attrs: { form: _vm.form } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }